import PropTypes from 'prop-types';
import { LinearProgress } from '@mui/material';

const styles = {
  bar: ({ palette, breakpoints }) => ({
    width: '100%',
    height: '20px',
    marginBlock: 1,
    backgroundColor: palette.colors.lightGrey,
    [breakpoints.up('md')]: {
      marginBlock: 2,
    },
  }),
};

const ProgressBar = ({ value = 0, max = 100 }) => (
  <LinearProgress color="success" variant="determinate" value={(value / max) * 100} sx={styles.bar} />
);

ProgressBar.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
};
export default ProgressBar;
